import React from 'react';
import styles from './Badge.module.scss';
import clsx from 'clsx';

export const Badge = ({
    children,
    variant = 'deliverable',
    size = 'md',
    className,
    icon: Icon,
    ...props
}) => {
    const variantClass = styles[`badge--${variant}`] || styles[`badge--deliverable`];
    const sizeClass = size === 'sm' ? styles['badge--sm'] : null;

    const combinedClasses = clsx(
        styles.badge,
        variantClass,
        sizeClass,
        className
    );

    const iconSize = size === 'sm' ? 11 : 12;

    return (
        <span className={combinedClasses} {...props}>
            {Icon && <Icon className={styles.badge__icon} size={iconSize} />}
            {children}
        </span>
    );
};
